'use client';

import { toast } from 'sonner';
import { useEffect, useState } from 'react';
import { usePathname } from 'next/navigation';
import { fetchMaintenanceConfig, type MaintenanceConfig } from "@/lib/api/client/maintenance";

export default function MaintenanceToast() {
  const pathname = usePathname();
  const [config, setConfig] = useState<MaintenanceConfig | null>(null);

  useEffect(() => {
    async function fetchConfig() {
      const data = await fetchMaintenanceConfig();
      setConfig(data);
    }

    fetchConfig();
  }, []);

  useEffect(() => {
    if (config) {
      const { maintenanceMessage, affectedRoutes, globalMaintenance } = config;

      // Check if global maintenance mode is enabled
      if (globalMaintenance) {
        toast.error(maintenanceMessage);
        return;
      }

      // Check if the current route matches affected routes
      const currentRoute = pathname;
      const isRouteAffected = (affectedRoutes as string[])?.some(
        (route: string) => {
          return new RegExp(route.replace('*', '.*')).test(currentRoute);
        }
      );

      if (isRouteAffected) {
        toast.error(maintenanceMessage, {
          duration: 10000,
        });
      }
    }
  }, [pathname, config]);

  return null;
}
